<!-- MENU -->
<ul class="sidebar-menu">

  <ng-container *ngIf="tokenExists">

    <li *ngFor="let item of menuItems" routerLinkActive="active" [routerLink]="item.route" [attr.title]="item.label | transloco">
      <i class="menu-fa-icon" [ngClass]="item.icon" aria-hidden="true"></i>
      <span>{{ item.label | transloco }}</span>
    </li>

  </ng-container>

  <!-- Cart -->
  <li *ngIf="cartItems.length > 0 && showCart" (click)="cartPopUpOpen()" [attr.title]="'Cart' | transloco">
    <i class="fa-solid fa-cart-shopping menu-fa-icon" aria-hidden="true"></i>
    <span>{{ "Cart" | transloco }}</span>
    <small class="badge">{{ cartItemCount }}</small>
  </li>

  <!-- Language -->
  <li
    class="language-menu-item"
    [class.open]="languageDropdownOpen"
    (click)="toggleLanguageDropdown($event)"
    [attr.title]="'Language' | transloco"
  >
    <i class="fa-solid fa-globe menu-fa-icon" aria-hidden="true"></i>
    <span>{{ "Language" | transloco }}</span>
    <i class="fa-solid fa-chevron-down language-arrow"></i>
  </li>

  <li *ngIf="languageDropdownOpen" class="language-options-wrap">
    <button type="button" class="language-option" (click)="setLanguage('ar', $event)" [attr.title]="'Arabic' | transloco">
      <img class="language-flag" src="/assets/ar.png" [alt]="'Arabic' | transloco" />
      <span>{{ "Arabic" | transloco }}</span>
    </button>
    <button type="button" class="language-option" (click)="setLanguage('en', $event)" [attr.title]="'English' | transloco">
      <img class="language-flag" src="/assets/en.png" [alt]="'English' | transloco" />
      <span>{{ "English" | transloco }}</span>
    </button>
    <button type="button" class="language-option" (click)="setLanguage('fr', $event)" [attr.title]="'French' | transloco">
      <img class="language-flag" src="/assets/fr.png" [alt]="'French' | transloco" />
      <span>{{ "French" | transloco }}</span>
    </button>
  </li>

  <!-- Logout -->
  <li *ngIf="tokenExists" (click)="logout()" [attr.title]="'Log out' | transloco">
    <i class="fa-solid fa-right-from-bracket menu-fa-icon" aria-hidden="true"></i>
    <span>{{ "Log out" | transloco }}</span>
  </li>

</ul>
